import { render, staticRenderFns } from "./Praise.vue?vue&type=template&id=7e7f5380&scoped=true&"
import script from "./Praise.vue?vue&type=script&lang=js&"
export * from "./Praise.vue?vue&type=script&lang=js&"
import style0 from "./Praise.vue?vue&type=style&index=0&id=7e7f5380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7f5380",
  null
  
)

export default component.exports